/*
 * Design address  ->  live b2c-website address.
 *
 * The design (vlookup-dramatic) uses its own URLs (/find-a-mentor, /about, ...).
 * The live site keeps its current addresses (revamp plan, decision 4: the
 * sitemap and Google rankings point at them). Every <Link>/<ButtonLink> in the
 * ported pages runs its href through toLive(), so the design's content file
 * can stay untouched. Add a row here when a new page is ported or an address
 * is decided.
 */
export const LIVE_ROUTES = {
  "/": "/",
  "/find-a-mentor": "/mentors",
  "/about": "/aboutus",
  "/our-impact": "/aboutus",
  "/events": "/event/upcoming",
  "/events/past": "/event/past",
  "/resources": "/resource-hub/all-posts",
  "/faq": "/faq",
  "/contact-us": "/contact-us",
  "/for-organisations": "/programs",
  "/mentorlookup": "/saas",
  // New page from the design (plan task 10) — placeholder until it is ported.
  "/how-it-works": "/how-it-works",
  // In-page anchors the design used for actions that are real pages here.
  "/#join": "/register",
  "/#login": "/login",
  "/#privacy": "/page/privacy-policy",
  "/#terms": "/page/terms-and-conditions",
};

export function toLive(href) {
  if (!href || typeof href !== "string") return href;
  if (LIVE_ROUTES[href]) return LIVE_ROUTES[href];
  const i = href.indexOf("#");
  if (i > 0) {
    const path = href.slice(0, i);
    if (LIVE_ROUTES[path]) return LIVE_ROUTES[path] + href.slice(i);
  }
  return href;
}
